import * as React from 'react';
import { connect } from 'react-redux';
import { IPbiReport } from '../PowerBI/business-objects/types';
import { getMyPinnedReports } from './redux-objects/actions';
import PowerBiViewController from '../PowerBI/PowerBiViewController';
import * as urls from '../shared/urls';
import CommentsButton from '../Comments/CommentsButton';
import ViewAllButton from '../DocumentViewer/ViewAllButton';

export interface IDashboardStateProps {
  webServiceURL: string;
  reports: IPbiReport[];
  history: any;
}
export interface IDashboardActionProps {
  getMyPinnedReports?: (url: string, locationId: number) => Promise<void>;
}

interface IDashboardProps extends IDashboardStateProps, IDashboardActionProps {}

class Dashboard extends React.Component<IDashboardProps> {
  componentDidMount() {
    this.loadPinnedReports();
  }

  loadPinnedReports = () => {
    this.props.getMyPinnedReports(urls.POWERBI_GET_MY_PINNED_REPORTS, 1);
  };

  public render() {
    return (
      <div>
        {/* This is only here to be uncommented when loading a specific report 
        for the purpose of debugging to find the datasetId since there is
        no handy way to do that on the powerbi site or desktop tool */}
        {/* <PowerBiViewController
          reportId='36f3079c-bb90-4de7-948e-29ea08a9cfc2'
          type='report'
        /> */}
        {this.props.reports &&
          this.props.reports.length > 0 &&
          Array.isArray(this.props.reports) &&
          this.props.reports[0]?.name.length > 0 && 
          this.props.reports.map((report) => {
            return (
              <div key={report.id}>
                <PowerBiViewController
                  reportId={report.reportId}
                  type='report'
                />
                <br />
                <hr />
              </div>
            );
          })}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    reports: state.Dashboard.reports,
  };
}

const mapDispatchToProps = {
  getMyPinnedReports,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
